import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { EventBannerUpload } from '@/components/events/EventBannerUpload';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

interface FormBannerUploadFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  description?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  freeForm?: boolean;
  className?: string;
}

export const FormBannerUploadField = <TFieldValues extends FieldValues>({
  control,
  name,
  label,
  description,
  required,
  disabled,
  freeForm,
  className,
}: FormBannerUploadFieldProps<TFieldValues>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem className={className}>
        <FormLabel>
          {label} {required && <span className="text-primary">*</span>}
        </FormLabel>
        <FormControl>
          <EventBannerUpload
            value={(field.value as string | undefined) ?? undefined}
            onChange={field.onChange}
            disabled={disabled}
            freeForm={freeForm}
          />
        </FormControl>
        {description && <FormDescription>{description}</FormDescription>}
        <FormMessage />
      </FormItem>
    )}
  />
);
FormBannerUploadField.displayName = 'FormBannerUploadField';
